export const setupUmbracoForms = {
	init: function() {
		const formWrappers = document.querySelectorAll('.js-form');
		if (formWrappers.length === 0) return;
		const umbForms = document.querySelectorAll('.umbraco-forms-form form');

		function dropdownArrow() {
			const dropdown = document.querySelector('.dropdown');
			if (!dropdown) return;
			dropdown.addEventListener('click', () => {
				dropdown.classList.toggle('dropdown--active');
			});
		}

		dropdownArrow();

		umbForms?.forEach((form) => {
			const submitButton = form.querySelector(
				'button[type="submit"], input[type="submit"], .js-submit-form'
			);
			if (!submitButton) return;

			submitButton.addEventListener('click', (e) => {
				e.preventDefault();

				if (validateForm(form)) {
					form.submit();
				}
			});

		});

		function handlePostSubmitEvents() {
			const contactUs = document.querySelector('.contact-us');
			const header = document.querySelector('.header');

			if (!contactUs || !header) return;

			const scrollPosition = header.offsetHeight - contactUs.offsetTop;

			window.scroll({
				top: scrollPosition,
				left: 0,
				behavior: 'smooth',
			});
		}

		function newFormReq() {
			const newFormBtn = document.querySelector('.js-form-reset');
			if (newFormBtn) {
				newFormBtn.addEventListener('click', (e) => {
					e.preventDefault();
					umbForms.forEach((form) => form.reset());
					switchForms(false);
				});
			}
		}

		function switchForms(submitted) {
			const formElement = document.getElementById('js-umb-form');
			const submittedElement = document.getElementById(
				'js-umb-form--submitted'
			);
			if (!formElement || !submittedElement) return;

			formElement.style.display = submitted ? 'none' : 'block';
			submittedElement.style.display = submitted ? 'block' : 'none';
		}

		function validateForm(form) {
			const requiredFields = form.querySelectorAll(
				'[required], [aria-required="true"]'
			);
			let isFormValid = true;
			let firstInvalid = null;

			form.querySelectorAll('.error-message').forEach((e) => e.remove());
			requiredFields.forEach((field) => {
				const parent = field.closest('.umbraco-forms-field');
				const messagePlace =
					parent.querySelector('.field-validation-valid') ||
					parent.querySelector('.field-validation-error');

				if (!messagePlace) return;
				messagePlace.remove();
			});

			requiredFields.forEach((field) => {
				const type = field.type;
				const value =
					type === 'checkbox' ? field.checked : field.value.trim();
				const isEmail =
					field.type === 'email' ||
					field.name.toLowerCase().includes('email');
				const regexPattern = field.dataset.valRegexPattern;
				const requiredMsg =
					field.dataset.valRequired || 'This field is required.';
				const regexMsg = field.dataset.valRegex || 'Invalid format.';

				let valid = true;

				if (!value) {
					valid = false;
					showError(field, requiredMsg);
				} else if (regexPattern) {
					const regex = new RegExp(regexPattern);
					if (!regex.test(value)) {
						valid = false;
						showError(field, regexMsg);
					}
				}

				if (!valid) {
					if (!firstInvalid) firstInvalid = field;
					isFormValid = false;
				}
			});

			if (!isFormValid && firstInvalid) {
				handlePostSubmitEvents();
			}

			return isFormValid;
		}

		function showError(field, message) {
			const parent = field.closest('.umbraco-forms-field-wrapper');
			const fieldId = field.id;
			const hasErrorMsg = parent.querySelector('.field-validation-error');

			if (hasErrorMsg) return;

			const msg = `
				<span class="field-validation-error" data-valmsg-for="${fieldId}" data-valmsg-replace="true" role="alert"><span>${message}</span></span>
			`;
			parent.insertAdjacentHTML('beforeend', msg);
		}
	},
};
